module.exports = __webpack_public_path__ + "public/Icons/welcomeIcon.png?ed754c8f";